interface ObjectUrlApi {
  createObjectURL(object: Blob): string;
  revokeObjectURL(url: string): void;
}

export interface ObjectUrlHandle {
  url: string;
  revoke: () => void;
}

export function createObjectUrlHandle(
  object: Blob,
  api: ObjectUrlApi = URL,
): ObjectUrlHandle {
  const url = api.createObjectURL(object);
  let revoked = false;

  return {
    url,
    revoke: () => {
      if (revoked) return;
      revoked = true;
      api.revokeObjectURL(url);
    },
  };
}
